import {
  useContext,
  createContext,
} from "react"
import type { SizePresetKey } from "./SizePresetKey"

export interface SliderValueContextValue {
  hasLabel: boolean;
  setHasLabel: (b: boolean) => void;
  sizePresetKey?: SizePresetKey;
  setSizePresetKey: (k: SizePresetKey) => void;
  unitWidth?: number;
  setUnitWidth: (v: number | undefined) => void;
  max?: string | number;
  setMax: (v: number | string) => void;
  placeholder?: string | number;
  setPlaceholder: (v: number | string) => void;
  value?: string | number;
  setValue: (v: number | string) => void;
}

type ContextType = SliderValueContextValue | null

export const SliderValueContext = createContext<ContextType>(null)

export function useSliderValueContext() {
  const context = useContext(SliderValueContext)

  if (context == null) {
    throw new Error("SliderValue components must be wrapped in <SliderValueContainer />")
  }

  return context
}
